export enum Constants {
    SET_GRADE_SCHEMAS = 'SET_GRADE_SCHEMAS'
}
